import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ProfileContext, ProfileManager } from '../profile';
import SignUpToContractPage from '../pages/SignUpToContractPage';

export interface Props {
  component: any;
  path: string;
  computedMatch?: object;
}

const isCompanyMember = (context: ProfileManager): boolean => {
  return context.profile !== null && context.profile.company_id !== null;
};

const hasContract = (context: ProfileManager): boolean => {
  return (
    context.profile !== null &&
    context.profile.company !== null &&
    context.profile.company.contract_id !== null
  );
};

export default function ContractRoute({
  component: Component,
  ...props
}: Props) {
  const context = React.useContext(ProfileContext);

  if (!isCompanyMember(context) || !hasContract(context)) {
    return <SignUpToContractPage />;
  }

  return <Component {...props} match={props.computedMatch} />;
}
